var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "el-row-line" },
        [
          _c("PageInfo"),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { float: "right" },
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.addMenu((_vm.parent_id = 0))
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-plus" }),
              _vm._v("\n      增加一级菜单"),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            [
              _c(
                "el-form",
                { attrs: { inline: true } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "250px" },
                          attrs: { filterable: "" },
                          model: {
                            value: _vm.systemId,
                            callback: function ($$v) {
                              _vm.systemId = $$v
                            },
                            expression: "systemId",
                          },
                        },
                        _vm._l(_vm.systemSelectOptions, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { value: item.value, label: item.label },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", icon: "el-icon-search" },
                          on: { click: _vm.systemIdChange },
                        },
                        [_vm._v("查询")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%", "margin-bottom": "20px" },
              attrs: {
                stripe: "",
                data: _vm.listData,
                "row-key": "uuid",
                border: "",
                "default-expand-all": "",
                "tree-props": {
                  children: "children",
                  hasChildren: "hasChildren",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "firstName", label: "一级菜单", width: "340" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.firstName
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  plain: "",
                                  type:
                                    scope.row.state === 1 ? "primary" : "info",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.tableEdit(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row.firstName) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.firstName
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary", plain: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.addMenu(
                                      (_vm.parent_id = scope.row.id)
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "el-icon-circle-plus" }),
                                _vm._v(" 增加二级菜单"),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "secondName", label: "二级菜单", width: "280" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.secondName
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  plain: "",
                                  type:
                                    scope.row.state === 1 ? "primary" : "info",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.tableEdit(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row.secondName) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.secondName
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary", plain: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.addAction(scope.row)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "el-icon-circle-plus" }),
                                _vm._v(" 增加操作功能名"),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "action", label: "操作功能名" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.action
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  plain: "",
                                  type:
                                    scope.row.state === 1 ? "success" : "info",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.tableActionEdit(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row.menu_name) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger", icon: "el-icon-delete" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteBtn(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n            删除\n          ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "close-on-press-escape": true,
            "close-on-click-modal": !1,
            title: _vm.isEdit ? "编辑" : "新增",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "menuForm",
              attrs: {
                rules: _vm.rules,
                model: _vm.dataForm,
                "label-width": "90px",
              },
            },
            [
              _vm.isMenu
                ? _c(
                    "div",
                    [
                      _vm.isEdit
                        ? _c(
                            "el-form-item",
                            { attrs: { prop: "id", label: "ID" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.dataForm.id,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataForm, "id", $$v)
                                  },
                                  expression: "dataForm.id",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isEdit
                        ? _c(
                            "el-form-item",
                            { attrs: { prop: "parent_id", label: "上级ID" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.dataForm.parent_id,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataForm, "parent_id", $$v)
                                  },
                                  expression: "dataForm.parent_id",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "component_name", label: "UI组件" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: "请输入UI组件名称",
                            },
                            model: {
                              value: _vm.dataForm.component_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "component_name", $$v)
                              },
                              expression: "dataForm.component_name",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "sort", label: "排序" } },
                        [
                          _c("el-input-number", {
                            model: {
                              value: _vm.dataForm.sort,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "sort", $$v)
                              },
                              expression: "dataForm.sort",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "hidden", label: "页面隐藏" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-value": 1,
                              "inactive-value": 0,
                              "active-text": "是",
                              "inactive-text": "否",
                            },
                            model: {
                              value: _vm.dataForm.hidden,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "hidden", $$v)
                              },
                              expression: "dataForm.hidden",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "no_cache", label: "页面缓存" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-value": 1,
                              "inactive-value": 0,
                              "active-text": "是",
                              "inactive-text": "否",
                            },
                            model: {
                              value: _vm.dataForm.no_cache,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "no_cache", $$v)
                              },
                              expression: "dataForm.no_cache",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "icon", label: "ICON" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { clearable: "", filterable: "" },
                              model: {
                                value: _vm.dataForm.icon,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dataForm, "icon", $$v)
                                },
                                expression: "dataForm.icon",
                              },
                            },
                            _vm._l(_vm.iconSelectOptions, function (item) {
                              return _c("el-option", {
                                key: item,
                                attrs: { value: item, label: item },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isMenu
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "menu_name", label: "菜单" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请输入菜单名称" },
                        model: {
                          value: _vm.dataForm.menu_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "menu_name", $$v)
                          },
                          expression: "dataForm.menu_name",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dataForm.parent_id !== 0
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "controller", label: "Controller" } },
                    [
                      !_vm.isMenu
                        ? _c("el-input", {
                            attrs: { placeholder: "" },
                            model: {
                              value: _vm.dataForm.controller,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "controller", $$v)
                              },
                              expression: "dataForm.controller",
                            },
                          })
                        : _c(
                            "el-select",
                            {
                              attrs: {
                                filterable: "",
                                disabled: !_vm.isMenu,
                                "allow-create": "",
                              },
                              model: {
                                value: _vm.dataForm.controller,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dataForm, "controller", $$v)
                                },
                                expression: "dataForm.controller",
                              },
                            },
                            _vm._l(
                              _vm.controllerSelectOptions,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    value: item.controller,
                                    label: item.controller,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isMenu
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "action", label: "action" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请输入action" },
                        model: {
                          value: _vm.dataForm.action,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "action", $$v)
                          },
                          expression: "dataForm.action",
                        },
                      }),
                      _vm._v(" "),
                      !_vm.isMenu
                        ? _c("div", { staticClass: "fz12 tip-text" }, [
                            _c("i", { staticClass: "el-icon-warning" }),
                            _vm._v("角色权限分配使用，需要唯一值"),
                          ])
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "url", label: "URL" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入URL" },
                    model: {
                      value: _vm.dataForm.url,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "url", $$v)
                      },
                      expression: "dataForm.url",
                    },
                  }),
                  _vm._v(" "),
                  !_vm.isMenu
                    ? _c("div", { staticClass: "fz12 tip-text" }, [
                        _c("i", { staticClass: "el-icon-warning" }),
                        _vm._v("前端按钮展示使用"),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.showOP
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "menu_name", label: "操作名" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请输入操作名" },
                        model: {
                          value: _vm.dataForm.menu_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "menu_name", $$v)
                          },
                          expression: "dataForm.menu_name",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "state", label: "状态" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "inactive-value": 0,
                      "active-text": "启用",
                      "inactive-text": "禁用",
                    },
                    model: {
                      value: _vm.dataForm.state,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "state", $$v)
                      },
                      expression: "dataForm.state",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-error" },
                  on: { click: _vm.resetForm },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-success" },
                  on: { click: _vm.onSave },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }